import { __assign, __rest } from "tslib";
import React from 'react';
import { cn } from '@bem-react/classname';
import { MessageBoxClose as Close } from './Close/MessageBox-Close';
import { MessageBoxButtons as Buttons } from './Buttons/MessageBox-Buttons';
import { MessageBoxTail as Tail } from './Tail/MessageBox-Tail';
import './MessageBox.css';
export { MessageBoxCorner as Corner } from './Corner/MessageBox-Corner';
export { MessageBoxTextWrap as Wrapper } from './TextWrap/MessageBox-TextWrap';
export var cnMessageBox = cn('MessageBox');
/**
 * Визуальный компонент для уведомлений, плашек и других паттернов.
 * @param {MessageBoxProps} props
 */
export var MessageBox = function (_a) {
    var actions = _a.actions, background = _a.background, children = _a.children, className = _a.className, corner = _a.corner, hasTail = _a.hasTail, innerRef = _a.innerRef, _b = _a.layout, layout = _b === void 0 ? 'plain' : _b, onClose = _a.onClose, _c = _a.hasClose, hasClose = _c === void 0 ? Boolean(onClose) : _c, opaque = _a.opaque, tailRef = _a.tailRef, _d = _a.tailType, tailType = _d === void 0 ? 'default' : _d, props = __rest(_a, ["actions", "background", "children", "className", "corner", "hasTail", "innerRef", "layout", "onClose", "hasClose", "opaque", "tailRef", "tailType"]);
    return (React.createElement("div", __assign({ className: cnMessageBox({ opaque: opaque, layout: layout, hasClose: onClose && hasClose }, [className]), ref: innerRef }, props),
        React.createElement("div", { className: cnMessageBox('Backdrop') },
            hasTail && React.createElement(Tail, { innerRef: tailRef, tailType: tailType }),
            background && React.createElement("div", { className: cnMessageBox('Background') }, background)),
        React.createElement("div", { className: cnMessageBox('Content') },
            children,
            onClose && hasClose && React.createElement(Close, { onClick: onClose })),
        actions && React.createElement(Buttons, null, actions),
        corner));
};
MessageBox.displayName = 'MessageBox';
